import src from "IMAGE";
export default { src, width: 32, height: 33, blurWidth: 0, blurHeight: 0};
